import PropTypes from 'prop-types'

const HORIZONTAL = {
  spacing: 8,
  titleProps: {
    size: 64,
    color: '#ffffff',
    lineHeight: 1.2,
  },
  descriptionProps: {
    size: 28,
    color: '#ffffff',
    lineHeight: 1.7,
  },
  svgProps: {
    className: 'svg-header-border',
  },
}

const VERTICAL = {
  spacing: 8,
  titleProps: {
    size: 64,
    color: '#13682B',
    lineHeight: 1.2,
  },
  descriptionProps: {
    size: 28,
    color: '#3D3D3D',
    lineHeight: 1.7,
  },
  svgProps: {
    className: 'svg-header-border',
  },
}

const CARD = {
  spacing: 8,
  titleProps: {
    size: 32,
    color: '#13682B',
    textAlign: 'middle',
    lineHeight: 1.2,
  },
  descriptionProps: {
    size: 28,
    color: '#666666',
    textAlign: 'middle',
    lineHeight: 1.4,
  },
  // FIXME: for some reason, if empty, it uses the classes above
  svgProps: {
    className: '',
  },
}

const MULTILINE = {
  spacing: 8,
  titleProps: {
    size: 32,
    color: '#13682B',
    lineHeight: 1.2,
  },
  descriptionProps: {
    size: 28,
    color: '#666666',
    lineHeight: 1.4,
  },
}

export const HEADER_THEME = {
  HORIZONTAL,
  VERTICAL,
  CARD,
  MULTILINE,
}

export const SPACING = 64
export const FOOTER_HEIGHT = 64

// PROPTYPES
export const PROPTYPES_RECT = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
}
